import React from 'react';
import { Box, Typography } from '@material-ui/core';
import IntlMessages from 'util/IntlMessages';
import { SampleQueries } from './IllustrativeContent';

/**
 * Category Suggestions Block Component
 */
const CatSuggestions = ({ illustrative = false, maxItems = 5, hidden, ...props }) => {
  if (hidden) return null;
  if (illustrative) return <SampleQueries kind="catSuggestions" maxItems={maxItems} />;

  // Deterministic width formula
  const getWidth = (i) => 60 + ((i * 23) % 40);

  return (
    <Box display="flex" flexDirection="column" gap={1} {...props}>
      <Typography variant="caption" style={{ color: '#9e9e9e', fontWeight: 600, paddingLeft: 4 }}>
        <IntlMessages id="ui.searchExperienceV2.core.blocks.catSuggestions.categories" />
      </Typography>

      <Box display="flex" flexDirection="column" gap={0.5}>
        {Array.from({ length: maxItems }).map((_, i) => (
          <Box
            // eslint-disable-next-line react/no-array-index-key
            key={`cat-${i}`}
            px={1.5}
            py={1}
            display="flex"
            alignItems="center"
            gap={1.5}
          >
            <Box width={24} height={24} bgcolor="#e0e0e0" borderRadius="50%" />
            <Box width={getWidth(i)} height={8} bgcolor="#eeeeee" borderRadius={4} />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default CatSuggestions;
